import axios from 'axios';

export const state = {
    referrerSlug: null,
    isLoading: false
};

export const mutations = {
    SET_REFERRER_SLUG(state, slug) {
        state.referrerSlug = slug;
    },

    START_LOADING(state) {
        state.isLoading = true;
    },

    STOP_LOADING(state) {
        state.isLoading = false;
    }
};

export const getters = {
    referrerSlug: state => state.referrerSlug,
    isLoading: state => state.isLoading
};

export const actions = {
    setReferrerSlug({ commit }, slug) {
        if (slug) {
            commit('SET_REFERRER_SLUG', slug);
        }
    }
}; 